@if (article()?.extras; as retention) {

<div class="row">
    @if (retention['retained_notes'].length > 3 || retention['retained_docket_source'].length) {
    <div class="col-md-6">
        <h5><strong>Retention</strong></h5>
        @if (retention['retained_notes']?.length > 3) {

        <p [innerHTML]="retention['retained_notes']"></p>

        }
        @if (retention['retained_docket_source'].length) {
        <court-documents [documents]="retention['retained_docket_source']" colsDefn="col-12" [showHeader]="false"></court-documents>
        }
    </div>
    }
    @if (retention['fee_notes']?.length > 3 || retention['fee_docket_source']?.length) {
    <div class="col-md-6">
        <h5><strong>Fees</strong></h5>
        @if (retention['fee_notes']?.length > 3) {

        <h3>Notes</h3>
        <p [innerHTML]="retention['fee_notes']"></p>

        }
        @if (retention['fee_docket_source']?.length) {

        <court-documents [documents]="retention['fee_docket_source']" colsDefn="col-12" [showHeader]="false"></court-documents>

        }
    </div>
    }
</div>

}